(function() {
'use strict';

angular
    .module('core')
    .directive('costBreakdown', costBreakdown);


function costBreakdown(tripService, $routeParams, broker, $location) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            costs: '=',
            totalLabel: '@',
            isPackage: '=',
            hideAgentDetail: '@',
            isInsurance: '@'
        },
        templateUrl: 'partials/home/costbreakdown',
        controller() {
            const cm = this;
            cm.isTravelAgentMode = TRPCONFIG.Domain.IsTravelAgentMode;
            const localPaymentsList = [22]; // id's of payable locally products

            cm.localPayable = function(costBreakdownItem) {
                return (localPaymentsList.indexOf(costBreakdownItem.TypeId) !== -1);
            };

            cm.payableNow = function(costBreakdownItem) {
                return (localPaymentsList.indexOf(costBreakdownItem.TypeId) === -1);
            };
        },
        controllerAs: 'cm',
        link(scope) {
            function sumCosts() {
                return (scope.costs || []).reduce((sum, cost) => {
                    sum.total += (cost.Quantity * cost.UnitAmount);
                    sum.netTotal += (cost.Quantity * cost.NetUnitAmount);
                    sum.totalTravelAgentCommission += (cost.Quantity * cost.TravelAgentCommission);
                    checkIsInsurance(cost);
                    return sum;
            }, { total: 0, netTotal: 0, totalTravelAgentCommission: 0 });
            }

            function setClientCurrencyCode() {
                if (scope.costs && (scope.costs.length >= 1)) {
                    if (scope.costs[0].ClientCurrencyCode) {
                        scope.clientCurrencyCode = scope.costs[0].ClientCurrencyCode;
                    } else {
                        tripService.getCurrency($routeParams.tripId).then(currency => {
                            scope.clientCurrencyCode = currency;
                        });
                    }
                }
            }

            function _setBinRangeDiscount(discount) {
                if (discount.data != null) {
                    scope.binRangeDiscount = discount.data[0];
                } else {
                    scope.binRangeDiscount = null;
                }
                calcCosts();
            }

            function calcCosts() {
                const sum = sumCosts();
                scope.total = sum.total;
                scope.netTotal = sum.netTotal;
                scope.totalTravelAgentCommission = sum.totalTravelAgentCommission;
                if (scope.binRangeDiscount != null) {
                    scope.total -= scope.binRangeDiscount.DiscountValue;
                    scope.deposit -= scope.binRangeDiscount.DiscountValue;
                }
                setClientCurrencyCode();
            }

            function checkIsInsurance(cost) {
                let isManageBooking = $location.path().indexOf('booking-details') > -1;
                let inInsuranceQoute = false;
                if (cost.Description) {
                    inInsuranceQoute = cost.Description.toLowerCase().indexOf('insurance') > -1;
                }
                if (!scope.isInsurance && isManageBooking && inInsuranceQoute) {
                    scope.isInsurance = true;
                }
            }

            scope.$watchCollection('costs', function() {
                calcCosts();
            });

            broker.subscribe('costBreakdownDirective', 'discountUpdated', _setBinRangeDiscount);

            scope.$on('$destroy', () => {
                broker.unsubscribe('costBreakdownDirective');
            });
        }
    };
}
})();
